import angular from 'angular';

angular.module('flowingly.filters').filter('typeof', function () {
  return function (obj: any) {
    return typeof obj;
  };
});
